<div>

  <div class="mb-5x">
    <h2 class="mb-2x">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.TITEL' | translate }}</h2>

    <div *ngIf="showGruendJahrError" class="col-sm-12 col-lg-12 p-0">
      <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUENDJAHR' | translate"
                      type="danger">
      </common-ui-card>
    </div>

    <div *ngIf="showFolgeJahrError" class="col-sm-12 col-lg-12 p-0">
      <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.FOLGEJAHR' | translate"
                      type="danger">
      </common-ui-card>
    </div>

    <div class="mt-3x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.VORAUS_EINKUENFTE_TITEL' | translate }}</h3>

      <div class="d-none d-sm-flex mb-3x mt-3x form-row">
        <p class="col-sm-3 common-ui-col-label">
          {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.STPFL' | translate }}
        </p>
        <p class="col-sm-3 common-ui-col-label">
          {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.EHEPARTNER' | translate }}
        </p>
        <p class="col-sm-3 common-ui-col-label">
          {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.STPFL_FOLGEJAHR' | translate }}
        </p>
        <p class="col-sm-3 common-ui-col-label">
          {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.EHEPARTNER_FOLGEJAHR' | translate }}
        </p>
      </div>

      <div class="mb-2x">
        <label
          class="col-form-label">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.LANDFORSTWIRTSCHAFT' | translate }}</label>
        <common-ui-lib-grundlage-vorauszahlungen (change)="checkMandatoryJahre()" [(data)]="data.landForstwirtschaft"
                                                 [readonly]="readonly" index="LandForstwirtschaft">
        </common-ui-lib-grundlage-vorauszahlungen>
      </div>

      <div class="mb-2x">
        <label
          class="col-form-label">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GEWERBEBETRIEB' | translate }}</label>
        <common-ui-lib-grundlage-vorauszahlungen (change)="checkMandatoryJahre()" [(data)]="data.gewerbebetrieb"
                                                 [readonly]="readonly" index="Gewerbebetrieb">
        </common-ui-lib-grundlage-vorauszahlungen>
      </div>

      <div class="mb-2x">
        <label
          class="col-form-label">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.SELBSTAENDIGERARBEIT' | translate }}</label>
        <common-ui-lib-grundlage-vorauszahlungen (change)="checkMandatoryJahre()" [(data)]="data.selbstaendigerArbeit"
                                                 [readonly]="readonly" index="SelbstaendigerArbeit">
        </common-ui-lib-grundlage-vorauszahlungen>
      </div>

      <div class="mb-2x">
        <label
          class="col-form-label">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.NICHTSELBSTAENDIGERARBEIT' | translate }}</label>
        <common-ui-lib-grundlage-vorauszahlungen [(data)]="data.nichtSelbstaendigerArbeit" [readonly]="readonly"
                                                 index="NichtSelbstaendigerArbeit">
        </common-ui-lib-grundlage-vorauszahlungen>
      </div>

      <div class="mb-2x">
        <label
          class="col-form-label">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.KAPITALVERMOEGEN' | translate }}</label>
        <common-ui-lib-grundlage-vorauszahlungen [(data)]="data.kapitalvermoegen" [readonly]="readonly"
                                                 index="Kapitalvermoegen">
        </common-ui-lib-grundlage-vorauszahlungen>
      </div>

      <div class="mb-2x">
        <label
          class="col-form-label">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.VERMIETUNGVERPACHTUNG' | translate }}</label>
        <common-ui-lib-grundlage-vorauszahlungen (change)="checkMandatoryJahre()" [(data)]="data.vermietungVerpachtung"
                                                 [readonly]="readonly" index="VermietungVerpachtung">
        </common-ui-lib-grundlage-vorauszahlungen>
      </div>

      <div class="mb-2x">
        <label
          class="col-form-label">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.SONSTIGEEINKUENFTE' | translate }}</label>
        <common-ui-lib-grundlage-vorauszahlungen [(data)]="data.sonstigeEinkuenfte" [readonly]="readonly"
                                                 index="SonstigeEinkuenfte">
        </common-ui-lib-grundlage-vorauszahlungen>
      </div>

    </div>

    <div class="mt-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.VORAUS_HOEHE_TITEL' | translate }}</h3>

      <div class="d-none d-sm-flex mb-3x mt-3x form-row">
        <p class="col-sm-3 common-ui-col-label">
          {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.STPFL' | translate }}
        </p>
        <p class="col-sm-3 common-ui-col-label">
          {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.EHEPARTNER' | translate }}
        </p>
        <p class="col-sm-3 common-ui-col-label">
          {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.STPFL_FOLGEJAHR' | translate }}
        </p>
        <p class="col-sm-3 common-ui-col-label">
          {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.EHEPARTNER_FOLGEJAHR' | translate }}
        </p>
      </div>

      <div class="mb-2x">
        <label
          class="col-form-label">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.SONDERAUSGABEN' | translate }}</label>
        <common-ui-lib-grundlage-vorauszahlungen [(data)]="data.sonderausgaben" [readonly]="readonly"
                                                 index="Sonderausgaben">
        </common-ui-lib-grundlage-vorauszahlungen>
      </div>

      <div class="mb-2x">
        <label
          class="col-form-label">{{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.STEUERABZUGSBETRAEGE' | translate }}</label>
        <common-ui-lib-grundlage-vorauszahlungen [(data)]="data.steuerabzugsbetraege" [readonly]="readonly"
                                                 index="Steuerabzugsbetraege">
        </common-ui-lib-grundlage-vorauszahlungen>
      </div>

    </div>

  </div>

</div>
